export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nueva inspección"])},
          "total": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Total"])},
          "value": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Valor"])},
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Volver a la lista de inspecciones"])},
          "title_container": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Campo ", _interpolate(_named("crop_field_code"))])},
          "cancel_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cancelar"])},
          "save_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Registrar"])}
        }
      },
      "en": {
        "labels": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["New inspection"])},
          "total": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Total"])},
          "value": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Value"])},
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Go back to inspections"])},
          "title_container": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Crop Field ", _interpolate(_named("crop_field_code"))])},
          "cancel_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cancel"])},
          "save_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Register"])}
        }
      }
    }
  })
}